<template>
  <div class="subtitle">
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="reds"
        @change="onChangeReds($event)"
      />
      <span style="background-color: red"></span> +30 dias
      <span
        v-b-tooltip.hover
        title="Cidadãos visitados há mais de 30 dias"
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="greens"
        @change="onChangeGreens($event)"
      />
      <span style="background-color: green"></span> 30 dias
      <span
        v-b-tooltip.hover
        title="Cidadãos visitados no últimos 30 dias"
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Subtitle',
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    setColor: {
      type: Boolean,
      default: () => {},
    },
    setRed: {
      type: Boolean,
      default: false,
    },
    setGreen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      reds: false,
      greens: false,
    }
  },
  watch: {
    setRed: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          this.reds = true
          this.greens = false
        } else {
          this.reds = false
        }
      },
      deep: true,
    },
    setGreen: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          this.reds = false
          this.greens = true
        } else {
          this.greens = false
        }
      },
      deep: true,
    },
    setColor: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          this.$emit('resetColor', this.setColor)
          this.greens = false
          this.reds = false
        }
      },
      deep: true,
    },
  },
  methods: {
    onChangeReds(event) {
      this.greens = false
      this.$emit('exibirVermelhos', event.target.checked)
    },
    onChangeGreens(event) {
      this.reds = false
      this.$emit('exibirVerdes', event.target.checked)
    },
  },
}
</script>

<style></style>
